import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WideSidebarState {
  openItems: Record<string, boolean>;
}

const initialState: WideSidebarState = {
  openItems: {},
};

export const wideSidebarSlice = createSlice({
  name: "wideSidebar",
  initialState,
  reducers: {
    toggleWideSidebarItem: (state, action: PayloadAction<string>) => {
      const itemKey = action.payload;
      if (state.openItems[itemKey]) {
        delete state.openItems[itemKey];
      } else {
        state.openItems[itemKey] = true;
      }
    },
    expandItems: (state, action: PayloadAction<string[]>) => {
      for (const key of action.payload) {
        state.openItems[key] = true;
      }
    },
  },
});

export const { toggleWideSidebarItem, expandItems } = wideSidebarSlice.actions;

export default wideSidebarSlice.reducer;
